<script setup>
import { get_trait_assessment } from '@/services/assessments';
import { get_module, get_max_val } from '@/services/traits';
import { get_trait } from '@/services/packages';
import { apexDashboard } from '@/data/dashboard/apexChart'
import { create_chart_label } from '@/helper';
import { ref, onMounted } from 'vue';

const props = defineProps({
  trait:{
    required: true
  },
  child:{
    required: true
  }
})

const trait_config = ref({})
const isLoading = ref(true)
onMounted(async ()=>{
  const moduleInf = await parse_module(props.trait.attributes.trait_id)
  const max_value = await parse_max_val(props.trait.attributes.trait_id)
  let assessment_progress_response = await get_trait_assessment({trait: props.trait.attributes.trait_id, child: props.child.id})
  let trait_response = await get_trait(props.trait.attributes.trait_id)
  const chart = await get_chart(props.trait, assessment_progress_response.result)
  
  trait_config.value = {
    ...trait_response.result.data,
    max_value,
    term: assessment_progress_response.result.term,
    chart,
    moduleInf
  }
  isLoading.value = false
})

async function parse_max_val(trait_id){
  let response = await get_max_val(trait_id)
  if (!response.error){
    return response.result.data.data
  }else{
    return (response.result.data)
  }
}

async function get_chart(trait, assessment_progress){
  // chart setting
  let series = [{
    name: 'Score',
    data: []
  }]
  let options = apexDashboard.options
  options.yaxis.max = find_max_chart_val(assessment_progress.assessments)
  // chart setting end
  let assessment_progresses = assessment_progress.assessments.included.filter(item => item.type == 'assessment_progress')
  let sorted_progress = assessment_progresses.sort((a,b) =>  parseInt(a.id) - parseInt(b.id))
  let latest_assessment_id = sorted_progress[sorted_progress.length - 1]?.attributes.assessment_id
  sorted_progress = sorted_progress.filter(item => item.attributes.assessment_id == latest_assessment_id)
  let labels = create_chart_label(sorted_progress)
  
  if (sorted_progress.length !== 0){
    series[0].data = sorted_progress.map((item, ind) => {
      let score = JSON.parse(item.attributes.score);
      // let date = dayjs(item.attributes.created_at).format('D/MM/YY')
      return {
        x: `${labels[ind]}`,
        y: score.length
      }
    })
  }
  return {
    show: sorted_progress.length == 0 ? false : true,
    series,
    options,
    assessment_progress
  }
}

async function parse_module(trait_id){
  let moduleResponse = await get_module(trait_id)
  if (!moduleResponse.error){
    return moduleResponse.result.data.data
  }else{
    return {}
  }
}

function find_max_chart_val(assessments){
  let count = assessments.included.filter(item=>item.type == 'indicator').length
  return count
}

const containsKey = (obj, key ) => Object.keys(obj).includes(key);
function remainder_length(trait){
  return parseInt(trait_config.value.max_value.attributes.value)  - trait.attributes.score
}

</script>

<template>
  <loadingCard v-if="isLoading"/>
  <template v-else>
    <div class="card growth-wrap border">
      <!-- Header -->
      <div class="card-header card-no-border">
        <div class="d-flex justify-content-between align-items-center">
          <div class="col-8">
            <h5>{{ trait_config.attributes.name }}</h5>
          </div>
          <!-- Score icon -->
          <div class="assessment-score-icon text-center">
            <vue-feather 
              v-for="item in trait.attributes.score"
              :key="item.id"
              class="m-auto text-warning" size="1rem" type="user"
            />
            <vue-feather 
              v-for="item in remainder_length(trait)"
              :key="item.id"
              class="m-auto text-secondary" size="1rem" type="user"
            />
          </div>
        </div>
        <!-- Module btn -->
        <div class="d-flex justify-content-between mt-1 align-items-center">
          <!-- Age Group -->
          <div v-if="trait_config.chart.show">
            <p>
              <span class="text-secondary"> Assessment Age Group </span><br>
              {{ trait_config.term?.name }}</p>
          </div>
        </div>
      </div>

      <div class="card-body pt-0 px-4">
        <template v-if="trait_config.chart.show">
          <p>{{  }}</p>
          <!-- Chart -->
          <div class="growth-wrapper">
            <apexchart height="200" 
              type="line" 
              :options="trait_config.chart.options" 
              :series="trait_config.chart.series"
            ></apexchart>
          </div>
          
          <!-- button list -->
          <div class="mt-3 row">
            <router-link class="btn btn-light-success rounded-pill m-1 ms-0"
              :to="{name: 'child-assessment-report', params: {trait_id: trait_config.id, child_id: child.id}}"
            >
              View Report
            </router-link>
          </div>
        </template>
        <empty-card 
          v-else
          text="Assessment hasn't been start yet"
        />
      </div>
    </div>
  </template>
</template>
  